import { useQuery } from '@mint-lib/query-client';
import { Categories, Tags } from '@mint-sdk/api-tags';

export const useTags = (flag?: boolean) => {
  const tags = useQuery({
    ...Tags.listQueryOptions({
      params: {},
    }),
    enabled: flag,
  });

  const categories = useQuery({
    ...Categories.listQueryOptions({
      params: {},
    }),
    enabled: flag,
  });

  const categoriesData = Object.values(categories.data || {}).flatMap(
    (item) => item.categories,
  );
  //TODO: will be removed when BE provides categoryType in tags
  const tagsWithCategories = tags.data?.map((tag) => {
    const category =
      categoriesData.find((category) => category.id === tag.category) || null;

    return {
      ...tag,
      category: category?.name || '',
      categoryType: category?.type,
      level: category?.level || 0,
    };
  });

  // tabs are used in LabelModal to filter tags by categoryType
  const tabs = Object.entries(categories.data ?? {}).map(([id, value]) => ({
    id,
    name: value.name,
  }));

  return {
    tags: tagsWithCategories,
    tabs,
    isLoading: tags.isLoading || categories.isLoading,
    isRefetching: tags.isRefetching || categories.isRefetching,
    refetch: tags.refetch,
  };
};
